export const HOMEPAGE = 'HOMEPAGE'